<script setup>
import { computed } from 'vue'
import Spinner from './Spinner.vue'

const props = defineProps({
    variant: {
        type: String,
        default: 'secondary',
    },
    size: {
        type: String,
        default: '',
    },
    tag: {
        type: String,
        default: '',
    },
    href: {
        type: String,
        default: null,
    },
    to: {
        type: [String, Object],
        default: null,
    },
    type: {
        type: String,
        default: 'button',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    block: {
        type: Boolean,
        default: false,
    },
    pill: {
        type: Boolean,
        default: false,
    },
    active: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    spinner: {
        type: Boolean,
        default: false,
    },
    caption: {
        type: String,
        default: null,
    },
    loadingCaption: {
        type: String,
        default: null,
    },
})

const emit = defineEmits(['click'])

const tag = computed(() => {
    if (props.tag) return props.tag
    if (props.to) return 'router-link'
    if (props.href) return 'a'
    return 'button'
})

const classes = computed(() => [
    'btn',
    `btn-${props.variant}`,
    props.size ? `btn-${props.size}` : '',
    props.block ? 'btn-block' : '',
    props.pill ? 'rounded-pill' : '',
    props.active ? 'active' : '',
])

const attrs = computed(() => {
    if (tag.value === 'router-link') return { to: props.to }
    if (tag.value === 'a') return { href: props.href }
    return { type: props.type, disabled: props.disabled || props.loading }
})

function onClick(e) {
    if (props.disabled || props.loading) {
        e.preventDefault()
        return
    }
    emit('click', e)
}
</script>

<template>
    <component
        :is="tag"
        v-bind="attrs"
        :class="classes"
        :aria-disabled="(disabled || loading) || undefined"
        @click="onClick"
    >
        <template v-if="loading">
            <slot name="loading">{{ loadingCaption }}</slot>
        </template>

        <template v-else>
            <slot>{{ caption }}</slot>
        </template>

        <Spinner v-if="loading && spinner" class="mr-1" small />
    </component>
</template>
